"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardEventsProvider = exports.useDashboardEventsContext = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
/**
 * @alpha
 */
var DashboardEventsContext = react_1.createContext({
    registerHandler: noop_1.default,
    unregisterHandler: noop_1.default,
});
DashboardEventsContext.displayName = "DashboardEventsContext";
/**
 * @alpha
 */
exports.useDashboardEventsContext = function () { return react_1.useContext(DashboardEventsContext); };
/**
 * @internal
 */
function DashboardEventsProvider(props) {
    var children = props.children, registerHandler = props.registerHandler, unregisterHandler = props.unregisterHandler;
    var value = react_1.useMemo(function () {
        return {
            registerHandler: registerHandler,
            unregisterHandler: unregisterHandler,
        };
    }, [registerHandler, unregisterHandler]);
    return react_1.default.createElement(DashboardEventsContext.Provider, { value: value }, children);
}
exports.DashboardEventsProvider = DashboardEventsProvider;
//# sourceMappingURL=DashboardEventsContext.js.map